import React from 'react';
import { Box, Typography } from '@mui/material';
import UsuarioTable from '../components/usuario/UsuarioTable';

const Usuarios: React.FC = () => {
  return (
    <Box>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom 
        sx={{ 
          fontWeight: 'bold',
          fontFamily: 'Arial, sans-serif',
          fontSize: '2.125rem',
          lineHeight: 1.235
        }}
      >
        Usuários
      </Typography>
      <UsuarioTable />
    </Box>
  );
};

export default Usuarios;
